var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualified2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.273774 5.776C-0.0911942 5.32481 -0.0911942 4.67519 0.273774 4.224C1.40993 2.81953 4.26455 0 7.37502 0C10.4855 0 13.3401 2.81953 14.4763 4.224C14.8412 4.67519 14.8412 5.32481 14.4763 5.776C13.3401 7.18047 10.4855 10 7.37502 10C4.26455 10 1.40993 7.18047 0.273774 5.776Z",
    fill: "#4F5F4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 2.5C5.99429 2.5 4.875 3.61929 4.875 5C4.875 6.38071 5.99429 7.5 7.375 7.5C8.75571 7.5 9.875 6.38071 9.875 5C9.875 3.61929 8.75571 2.5 7.375 2.5Z",
    fill: "#F8FEF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualified2);
export default __webpack_public_path__ + "static/media/qualified2.fe8fbad5f7cfaf385e79f21593954a0e.svg";
export { ForwardRef as ReactComponent };